import {
  Icon,
} from 'bd-web-components'
import {
  PRIMARY_RED_01,
} from 'bd-web-components/src/utils/dash-colors'
import {
  DataContainer,
  EventInfo,
  EventTitle,
  EventCategory,
  EventUrl,
  EventTime,
  VenueInfo,
  VenueName,
  VenueLocation,
  ArtistsSection,
  ArtistsTitle,
  ArtistList,
  ArtistItem,
  ArtistName,
  ArtistType,
  TicketingInfo,
  TicketingTitle,
  PriceRange,
  PriceItem,
  PriceLabel,
  PriceValue,
} from './styles'

interface Artist {
  name: string
  spotifyId: string
}

interface SpotifyEventData {
  idSpotifyEvent: string
  eventId: number
  artists: Artist[]
  artistSupportings: Artist[]
  eventCategory: 'CONCERT' | 'FESTIVAL'
  name: string
  url: string
  startTime: string
  venueId: number
  venueName: string
  venueCity: string
  venueState: string
  venueCountry: string
  venueLatitude: string
  venueLongitude: string
  ticketMinimumPrice: string
  ticketMaximumPrice: string
  ticketCurrency: string
  createdAt: string
  updatedAt: string
  deletedAt: string | null
}

interface SpotifyDataProps {
  data: SpotifyEventData
}

export function SpotifyData({ data }: SpotifyDataProps) {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  const formatPrice = (price: string, currency: string) => {
    const numericPrice = parseFloat(price)
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: currency === 'BRL' ? 'BRL' : 'USD'
    }).format(numericPrice)
  }

  return (
    <DataContainer>
      <EventInfo>
        <EventTitle>{data.name}</EventTitle>
        <EventCategory>{data.eventCategory}</EventCategory>
        <EventUrl href={data.url} target="_blank" rel="noopener noreferrer">
          Ver evento
        </EventUrl>
        <EventTime>
          <Icon
            fill={PRIMARY_RED_01}
            classes=""
            iconName="calendar"
            width={16}
            height={16}
          />
          {formatDate(data.startTime)}
        </EventTime>
      </EventInfo>

      <VenueInfo>
        <VenueName>{data.venueName}</VenueName>
        <VenueLocation>
          {data.venueCity}, {data.venueState}
        </VenueLocation>
      </VenueInfo>

      <ArtistsSection>
        <ArtistsTitle>Artistas</ArtistsTitle>
        <ArtistList>
          {data.artists?.map((artist) => (
            <ArtistItem key={artist.spotifyId}>
              <ArtistName>{artist.name}</ArtistName>
              <ArtistType>Artista Principal</ArtistType>
            </ArtistItem>
          ))}
          {data.artistSupportings?.map((artist) => (
            <ArtistItem key={artist.spotifyId}>
              <ArtistName>{artist.name}</ArtistName>
              <ArtistType>Suporte</ArtistType>
            </ArtistItem>
          ))}
        </ArtistList>
      </ArtistsSection>

      <TicketingInfo>
        <TicketingTitle>Informações de Ingressos</TicketingTitle>
        <PriceRange>
          <PriceItem>
            <PriceLabel>Preço mínimo</PriceLabel>
            <PriceValue>
              {formatPrice(data.ticketMinimumPrice, data.ticketCurrency)}
            </PriceValue>
          </PriceItem>
          <PriceItem>
            <PriceLabel>Preço máximo</PriceLabel>
            <PriceValue>
              {formatPrice(data.ticketMaximumPrice, data.ticketCurrency)}
            </PriceValue>
          </PriceItem>
        </PriceRange>
      </TicketingInfo>
    </DataContainer>
  )
}